import React, { Component } from 'react'

export class ResultsLine extends Component {
    render() {
        const bgColor = {
            backgroundColor: this.props.bgcolor,
            opacity: this.props.opac
        }
        return (
            <div className="circleLine">
                <div style={bgColor} className="circleResult"></div>
            </div>
        )
    }
}

export default ResultsLine
